import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import RemoteComponent from '../ModuleFederation/RemoteComponent';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import envConfig from '@ey/voltron-config';

function EngagementMap(props) {
	const engagement = useSelector((store) => store.engagement);
	const [showEngagementMapLoadingIndicator, setshowEngagementMapLoadingIndicator] = useState(true);

	const onEngagementMapLoadSuccesCallBack = () => {
		setshowEngagementMapLoadingIndicator(false);
	};

	return (
		<>
			{props.showEngagementMap ? (
				<>
					<LoadingIndicator show={showEngagementMapLoadingIndicator} fullscreen />
					<StyledMappingModuleModalBody className="customScrollbar">
						<RemoteComponent
							//key="engagementmap"
							id="engagementmap"
							adConfig={envConfig.ad}
							engagementId={engagement.engagementId}
							toggleModal={props.onClose}
							showEngagementMap={props.showEngagementMap}
							darkHeader
							showDummyTriggerButton={false}
							onLoadSucess={onEngagementMapLoadSuccesCallBack}
							onLoadError={() => {								
								props.onLoadError();
								onEngagementMapLoadSuccesCallBack();
							}}
						/>
					</StyledMappingModuleModalBody>
				</>
			) : null}
		</>
	);
}

export default EngagementMap;

const StyledMappingModuleModalBody = styled.section`
	.map-ey-accounts-outer-container {
		background-color: transparent;
	}
`;
